import styled, { css } from "styled-components";

export const InputWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;

    padding: ${theme.spacings[4]} ${theme.spacings[8]};

    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.spacings[6]};

    border: 1px solid ${theme.colors.gray900};
    border-radius: 0.4rem;

    cursor: text;

    background: ${theme.colors.white};

    .textInput {
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
      background-color: ${theme.colors.white};
    }
  `}
`